import { YupSchema } from 'services/yup/types'
import { yupArray, yupIgnore, yupString } from 'services/yup'
import { packageBaseVS, presetBaseVS } from './packageBase'
import {
  LocationPackage,
  LocationPreset,
} from 'services/api/entities/catalog/packages/locationPackage'
import { LocationArrangementName } from 'types/form'

const locationPresetVS: YupSchema<LocationPreset> = presetBaseVS.shape({
  arrangement: yupString<LocationArrangementName>().required(),
})

export const locationPackageVS: YupSchema<LocationPackage> =
  packageBaseVS.shape({
    products: yupArray(locationPresetVS).min(1),
    isBundledPackage: yupIgnore(),
  })
